import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';

const Pricing = () => {
  const plans = [
    {
      name: "Starter",
      price: "From $999",
      description: "Perfect for new businesses",
      features: [
        "Up to 25 products",
        "Standard template",
        "Payments & shipping setup",
        "Basic SEO optimization",
        "30-day support"
      ],
      popular: false,
      color: "#3b82f6"
    },
    {
      name: "Growth",
      price: "From $2,499",
      description: "For growing businesses",
      features: [
        "Up to 200 products",
        "Custom pages",
        "Email automation",
        "Advanced SEO",
        "Performance optimization",
        "60-day support"
      ],
      popular: true,
      color: "#8b5cf6"
    },
    {
      name: "Scale",
      price: "Custom",
      description: "For enterprise needs",
      features: [
        "Unlimited products",
        "Headless architecture",
        "Multi-channel sync",
        "Marketplace integration",
        "Custom development",
        "90-day support"
      ],
      popular: false,
      color: "#10b981"
    }
  ];

  return (
    <section id="pricing" className="section" style={{ background: '#f8fafc' }}>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 style={{
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            fontWeight: '700',
            color: '#1e293b',
            marginBottom: '16px'
          }}>
            Choose Your Launch Package
          </h2>
          <p style={{
            fontSize: '1.25rem',
            color: '#64748b',
            maxWidth: '600px',
            margin: '0 auto 24px'
          }}>
            All packages include our 15-day launch guarantee
          </p>
          <p style={{
            fontSize: '1rem',
            color: '#667eea',
            fontWeight: '500'
          }}>
            Payment plans available
          </p>
        </motion.div>

        <div className="grid grid-3">
          {plans.map((plan, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.2, duration: 0.6 }}
              viewport={{ once: true }}
              className="card"
              style={{
                position: 'relative',
                background: plan.popular ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'white',
                color: plan.popular ? 'white' : '#1e293b',
                border: plan.popular ? 'none' : '2px solid #e2e8f0',
                transform: plan.popular ? 'scale(1.05)' : 'scale(1)',
                zIndex: plan.popular ? 2 : 1
              }}
            >
              {plan.popular && (
                <div style={{
                  position: 'absolute',
                  top: '-12px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  background: '#fbbf24',
                  color: '#1f2937',
                  padding: '8px 24px',
                  borderRadius: '20px',
                  fontSize: '14px',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px'
                }}>
                  <Star size={16} fill="currentColor" />
                  Most Popular
                </div>
              )}

              <div className="text-center mb-8">
                <h3 style={{
                  fontSize: '1.5rem',
                  fontWeight: '700',
                  marginBottom: '16px'
                }}>
                  {plan.name}
                </h3>
                <p style={{
                  fontSize: '1rem',
                  opacity: 0.8
                }}>
                  {plan.description}
                </p>
              </div>

              <ul style={{
                listStyle: 'none',
                padding: 0,
                margin: '0 0 32px 0'
              }}>
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex} style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    marginBottom: '12px',
                    fontSize: '1rem'
                  }}>
                    <Check 
                      size={20} 
                      color={plan.popular ? 'white' : plan.color}
                      style={{ flexShrink: 0 }}
                    />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <a 
                href="#lead-form"
                className="btn"
                style={{
                  width: '100%',
                  background: plan.popular ? 'white' : `linear-gradient(135deg, ${plan.color} 0%, ${plan.color}dd 100%)`,
                  color: plan.popular ? plan.color : 'white',
                  border: 'none',
                  boxShadow: plan.popular ? '0 4px 15px rgba(0, 0, 0, 0.2)' : `0 4px 15px ${plan.color}40`
                }}
              >
                Request My Quote
              </a>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center"
          style={{ marginTop: '48px' }}
        >
          <p style={{
            fontSize: '1rem',
            color: '#64748b',
            marginBottom: '16px'
          }}>
            Trust strip: 150+ launches completed • Avg time to launch: 15 days • 30-day support included
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Pricing;
